<template>
  <el-dialog
    :visible="visible"
    width="1000px"
    @close="closeFn"
    title="绑定信息"
  >
    <div class="details">
      <div class="details-search">
        <el-form
          ref="form"
          :model="form"
          inline
          label-width="80px"
        >
          <el-form-item label="设备编号">
            <el-input v-model.trim="form.terminalNo" placeholder="请输入设备编号" />
          </el-form-item>
        </el-form>
        <el-button
          size="small"
          type="primary"
          @click="getData"
        >查询</el-button>
      </div>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="400px"
        :data="tableData"
        border
        stripe
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="userName"
          label="司机账号"
          minWidth="120"
          align="center"
        />
        <el-table-column
          prop="terminalNo"
          label="设备编号"
          minWidth="130"
          align="center"
        />
        <el-table-column
          property="createTime"
          label="绑定时间"
          minWidth="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="operate"
          label="操作"
          width="120"
          align="center"
          v-slot="{ row }"
        >
          <el-tag @click="onUpBind(row)" type="warning" class="cursor">解绑</el-tag>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getData"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
  </el-dialog>
</template>
<script>
export default {
  name:'DetailsInfo',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    userId:{
      type:Number,
      default:null
    }
  },
  data(){
    return {
      loading:false,
      tableData:[],
      currentPage:1,
      pageSize:50,
      total:0,
      form:{
        terminalNo:''
      }
    }
  },
  watch:{
    visible:{
      handler(val){
        val && this.getData();
      },
      deep:true
    }
  },
  methods:{
    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    //关闭弹框
    closeFn(){
      this.currentPage = 1;
      this.pageSize = 50;
      this.total = 0;
      this.$emit('update:visible',false);
    },
    // 解绑
    onUpBind(row){
      this.$msgBox.confirm('是否确认解绑该司机?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try{
          const { code, msg } = await this.$API.deviceUnbind({ terminalNo:row.terminalNo });
          if(code !== 0) throw { msg };
          this.currentChange(1);
          this.$msg({
            type: 'success',
            message: '解绑成功!'
          });
        }catch({ msg }){
          this.$msg({
            type:'error',
            message:msg,
          });
        }

      }).catch(() => {});
    },
    //上传文件
    async getData(){
      let params = {
        pageSize:this.pageSize,
        pageNumber:this.currentPage,
        terminalNo:this.form.terminalNo,
        userId:this.userId
      };
      try {
        this.loading = true;
        const { data, total, code, msg } = await this.$API.getBinddeviceInfo(params);
        if(code !== 0) throw { msg };
        this.total = total;
        this.tableData = data?.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        })) ?? [];
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      } finally{
        this.loading = false;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header{
  border-bottom: 1px solid #eee;
}
::v-deep .el-dialog__body{
  padding: 0;
}
.details{
  padding: 10px;
  &-search{
    display: flex;
    align-items: center;
  }
  .cursor{
    cursor: pointer;
  }
}

</style>
